import React from 'react';

import cn from 'classnames';

import styles from './note-item.module.scss';
import Skeleton from '@/components/common/Skeleton/Skeleton';

interface INoteItemSkeletonProps {
  className?: string;
}

export default function NoteItemSkeleton({ className }: INoteItemSkeletonProps) {
  return (
    <div className={cn(styles.note, className)}>
      <div className={styles.meta}>
        <span className={styles.username}>
          <span><Skeleton width={150} /></span>
        </span>
        <span className={styles.date}>
          <span><Skeleton width={150} /></span>
        </span>
      </div>
      <div className={styles.text}>
        <Skeleton count={3} />
      </div>
    </div>
  );
}
